<!-- //Home Page -->
<!-- <app-loader [ShowLoader]="globalService.showLoader"></app-loader>
 -->

<!-- Home list -->
<div class="home-page row" *ngIf="resturantLocationStatus == 'home'">
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 mb-4 col-xs-12" *ngFor="let obj of resturantResponseArrayModel.ResturantLists| slice:0:4;">
        <div class="wrapper-list-thumb">
            <div class="room-img-wrapper ">
                <a [routerLink]="['/restaurants',obj._id,false]">
                    <img [src]="obj.ResturantImages[0]" *ngIf="obj.ResturantImages && obj.ResturantImages[0];else  otherImage" />
                    <ng-template #otherImage>
                        <img src="assets/images/No_Image_Available.jpg" />
                    </ng-template>
                </a>
            </div>
            <div class="list-thumb-content">
                <p class="type-info secondary-text" *ngIf="obj.ResturantType && obj.ResturantType.ResturantTypeLangs && obj.ResturantType.ResturantTypeLangs.length;else otherResturant">
                    <span>{{ obj.ResturantType.ResturantTypeLangs[0].Value }}</span>
                </p>
                <ng-template #otherResturant>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>
                <p class="title-info" *ngIf="obj.ResturantNameLangs && obj.ResturantNameLangs.length;else otherResturantName">
                    <a class="primary-text" [routerLink]="['/restaurants',obj._id,false]">{{ obj.ResturantNameLangs[0].Value }}</a>
                </p>
                <ng-template #otherResturantName>
                    <p class="title-info"><a class="primary-text" [routerLink]="['/restaurants',obj._id,false]">{{ 'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
                      {{ getCategoryName(obj.Category) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- //Home list -->

<!-- Home Page Menu Page -->
<div class="home-page row" *ngIf="resturantLocationStatus == 'homePageMenu'">
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 mb-4 col-xs-12" *ngFor="let obj of resturantResponseArrayModel.ResturantLists">
        <div class="wrapper-list-thumb position-relative wrapper-list-thumb-manage">
            <div class="category-tag" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
               <span 
                    class="badge"
                    [style.color]="obj?.Category?.CategoryColor"
                    style="background-color: transparent;">
                    {{ getCategoryName(obj.Category) }}
                </span>
            </div>
            <div class="delete-image"> <i class="material-icons" (click)="deactivateFromHome(obj._id)" [appAccessCheck]="'homepage-menu'" [givenButton]="'delete'">delete</i></div>
            <div class="room-img-wrapper">
                <img [src]="obj.ResturantImages[0]" *ngIf="obj.ResturantImages && obj.ResturantImages[0];else  otherImage" />
                <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                </ng-template>
            </div>
            <div class="list-thumb-content">
                <p class="type-info  secondary-text" *ngIf="obj.ResturantType && obj.ResturantType.ResturantTypeLangs && obj.ResturantType.ResturantTypeLangs.length;else otherResturant">
                    {{ obj.ResturantType.ResturantTypeLangs[0].Value }}</p>
                <ng-template #otherResturant>
                    <p class="type-info  secondary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>
                <p class="title-info primary-text" *ngIf="obj.ResturantNameLangs && obj.ResturantNameLangs.length;else otherResturantName">
                    {{ obj.ResturantNameLangs[0].Value }}
                </p>
                <ng-template #otherResturantName>
                    <p class="title-info primary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>
            </div>
        </div>
    </div>
</div>



<!---Home Front View-->
<div class="room-front-view restaurant-guest-dashboard row" *ngIf="resturantLocationStatus == 'resturantFrontView'">
    <div class="col-12" *ngIf="categories && categories.length > 0">
        <div class="category-filter-section mb-4">
            <div class="category-filter-outer">
                <button type="button" class="category-nav-arrow"
                    (click)="scrollCategoryStrip(-1, restaurantCatStrip)"
                    aria-label="Scroll categories left">
                    <span aria-hidden="true">&#8249;</span>
                </button>
                <div class="category-filter" #restaurantCatStrip>
                <button class="filter-btn" [class.active]="selectedCategory === null" (click)="filterByCategory(null)">
                    {{'All'|translate}} <span class="count-badge">{{totalRestaurantCount}}</span>
                </button>
                <button class="filter-btn"
                  *ngFor="let cat of categories"
                  [class.active]="selectedCategory === cat._id"
                  [ngStyle]="selectedCategory === cat._id ? {} : { color: cat.CategoryColor }"
                  (click)="filterByCategory(cat._id)">       

                  {{ getCategoryName(cat) }}
                  <span class="count-badge">{{ cat.Count || 0 }}</span>
                </button>
                </div>
                <button type="button" class="category-nav-arrow"
                    (click)="scrollCategoryStrip(1, restaurantCatStrip)"
                    aria-label="Scroll categories right">
                    <span aria-hidden="true">&#8250;</span>
                </button>
            </div>
        </div>
    </div>
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 mb-4 col-xs-12" *ngFor="let obj of resturantResponseArrayModel.ResturantLists">
        <div class="wrapper-list-thumb">
            <div class="room-img-wrapper">
                <a [routerLink]="['/restaurants',obj._id,false]">
                    <img [src]="obj.ResturantImages[0]" *ngIf="obj.ResturantImages && obj.ResturantImages[0];else  otherImage" />
                    <ng-template #otherImage>
                        <img src="assets/images/No_Image_Available.jpg" />
                    </ng-template>
                </a>
            </div>
            <div class="list-thumb-content">
                <p class="type-info secondary-text" *ngIf="!globalService.validateIsEmpty(obj.ResturantType?.ResturantTypeLangs);else otherResturant">
                    <span>{{ obj.ResturantType.ResturantTypeLangs[0].Value }}</span>
                </p>
                <ng-template #otherResturant>
                    <p class="type-info secondary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>
                <p class="title-info" *ngIf="obj.ResturantNameLangs && obj.ResturantNameLangs.length;else otherResturantName">
                    <a class="primary-text" [routerLink]="['/restaurants',obj._id,false]" [matTooltip]="obj.ResturantNameLangs[0].Value">{{ obj.ResturantNameLangs[0].Value }}</a>
                </p>
                <ng-template #otherResturantName>
                    <p class="title-info"><a class="primary-text" [routerLink]="['/restaurants',obj._id,false]">{{ 'NotAvailable'|translate }}</a></p>
                </ng-template>
                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                    <span
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
                      {{ getCategoryName(obj.Category) }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="pagination" *ngIf="resturantResponseArrayModel.ResturantLists">
        <span *ngIf="resturantResponseArrayModel.ResturantLists.length">
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
      </mat-paginator>
    </span>
    </div>

</div>
<!---//Home Front View-->

<!---Restaurant Manage Page-->
<div class="room-manage-page row" *ngIf="resturantLocationStatus == 'resturantManagePage'">
    <div class="gallery-item-list col-lg-3 col-md-4 col-sm-6 mb-4 col-xs-12" *ngFor="let obj of resturantResponseArrayModel.ResturantLists">
        <div class="wrapper-list-thumb position-relative">
            <div class="room-img-wrapper">
                <img [src]="obj.ResturantImages[0]" *ngIf="obj.ResturantImages && obj.ResturantImages[0];else  otherImage" />
                <ng-template #otherImage>
                    <img src="assets/images/No_Image_Available.jpg" />
                </ng-template>
            </div>
            <span class="restock-warning nunito position-absolute" *ngIf="thresholdCheck(obj._id)" >{{'SoonOutofStock'|translate}}</span>
            <div class="list-thumb-content">
                <p class="type-info  secondary-text" *ngIf="obj.ResturantType && obj.ResturantType.ResturantTypeLangs && obj.ResturantType.ResturantTypeLangs.length;else otherResturant">
                    {{ obj.ResturantType.ResturantTypeLangs[0].Value }}</p>
                <ng-template #otherResturant>
                    <p class="type-info  secondary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>
                 <div class="d-flex justify-between slide-toggle-wrapper">

                <p class="title-info primary-text" *ngIf="obj.ResturantNameLangs && obj.ResturantNameLangs.length;else otherResturantName">
                    {{ obj.ResturantNameLangs[0].Value }}
                </p>
                <mat-slide-toggle class="manage-dept-toggle" [checked]="obj.IsActive"
                    (change)="onToggleChange($event,obj?._id,obj?.ResturantNameLangs[0]?.Value)"
                    [appAccessCheck]="'restaurants'" [givenButton]="'edit'">
                  </mat-slide-toggle>
                </div>
                <ng-template #otherResturantName>
                    <p class="title-info primary-text">{{ 'NotAvailable'|translate }}</p>
                </ng-template>

                <div class="category-info mt-2" *ngIf="obj.Category && obj.Category.CategoryNames && obj.Category.CategoryNames.length > 0">
                   <span 
                      class="badge"
                      [style.color]="obj?.Category?.CategoryColor"
                      style="background-color: transparent;">
                      {{ getCategoryName(obj.Category) }}
                    </span>
                </div>
                 
            </div>
            <div class="button-section" [class.restaurant-staff-action-grid]="globalService.isPortalStaffRoute()">
                <button class="btn btn-primary restaurant-view-action" type="button" (click)="detailResturantView(obj._id)" [appAccessCheck]="'restaurants'" [givenButton]="'view'"><i class="material-icons">remove_red_eye</i>{{'ViewDetail'|translate}}</button>
                <button class="btn btn-secondary restaurant-edit-action" type="button" (click)="editResturantView(obj._id)" [appAccessCheck]="'restaurants'" [givenButton]="'restaurant-card-edit'"><i class="material-icons">create</i>{{'Edit'|translate}}</button>
                <button *ngIf="globalService.isPortalStaffRoute()" class="btn btn-success restaurant-take-order-action" type="button" [disabled]="restaurantLookupInProgress" (click)="openRestaurantOrders(obj)" [appAccessCheck]="'Manage-Restaurant-Orders'" [givenButton]="'manage'"><i class="material-icons">room_service</i>{{'Orders'|translate}}</button>
            </div>
        </div>
    </div>

    <div class="pagination" *ngIf="resturantResponseArrayModel.ResturantLists">
        <span *ngIf="resturantResponseArrayModel.ResturantLists.length">
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = getPaginatorData($event)" *ngIf="length > 0">
      </mat-paginator>
    </span>
    </div>
</div>
<!---//Restaurant Manage Page-->

<ng-template #restaurantOrderRoomDialog>
  <div class="restaurant-order-room-dialog">
    <div class="modal-header d-flex align-items-start justify-content-between">
      <div>
        <span class="restaurant-order-dialog-context">{{ pendingRestaurantName }}</span>
        <h3 class="restaurant-order-dialog-title">{{ 'New order' | translate }}</h3>
      </div>
      <button mat-dialog-close type="button" class="restaurant-order-dialog-close"
        [disabled]="restaurantOrderContextLookupInProgress"
        [attr.aria-label]="'Close' | translate">
        <i class="material-icons" aria-hidden="true">close</i>
      </button>
    </div>

    <div class="modal-body-content">
      <mat-form-field class="restaurant-order-dialog-form-field">
        <mat-label>
          {{ 'Room Number' | translate }}<span class="restaurant-order-dialog-required">*</span>
        </mat-label>
        <input matInput id="restaurant-order-room-number" class="restaurant-order-dialog-input" type="text" maxlength="30"
          autocomplete="off" [disabled]="restaurantOrderContextLookupInProgress"
          [value]="pendingRoomNumber" (input)="onPendingRoomNumberInput($event)"
          (blur)="pendingRoomTouched = true" (keyup.enter)="continueRestaurantOrder()" />
        <mat-hint *ngIf="pendingRoomError">
          <span class="restaurant-order-dialog-error">{{ pendingRoomError | translate }}.</span>
        </mat-hint>
      </mat-form-field>

      <p class="restaurant-order-dialog-error restaurant-order-dialog-context-error" *ngIf="roomOrderContextError">
        {{ roomOrderContextError | translate }}
      </p>
    </div>

    <div class="modal-footer-content d-flex align-items-center justify-content-end">
      <button class="btn btn-primary text-white" type="button"
        [disabled]="restaurantOrderContextLookupInProgress || pendingRestaurantOrderInvalid"
        (click)="continueRestaurantOrder()">
        {{ (restaurantOrderContextLookupInProgress ? 'Please wait' : 'Continue') | translate }}
      </button>
    </div>
  </div>
</ng-template>
